"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _odAnimate = _interopRequireDefault(require("@tencent/od-animate"));

var _info = _interopRequireDefault(require("./info"));

var _dropdown_props = require("./dropdown_props");

var _dropdown_toggle = _interopRequireDefault(require("./dropdown_toggle"));

var _classname_map = _interopRequireDefault(require("./config/classname_map"));

var _index = require("./utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Dropdown =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Dropdown, _PureComponent);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setOpen", function () {
      var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      _this.setState({
        open: open
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentClick", function (event) {
      var _this$props = _this.props,
          propsOpen = _this$props.open,
          onOpen = _this$props.onOpen;
      var open = _this.state.open; // 如果不是内部点击，就关闭掉

      if (open && !_this._insideClick) {
        // 根据配置延迟下
        clearTimeout(_this.hoverTimeout);

        if (typeof propsOpen === 'undefined') {
          _this.setState({
            open: false
          });
        }

        if ((0, _spauiUtils.isFunction)(onOpen)) {
          onOpen(event, false);
        }
      }

      _this._insideClick = false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleWindowResize", function () {
      _this.setContentPosition();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpen", function (event, currentOpen) {
      var _this$props2 = _this.props,
          propsOpen = _this$props2.open,
          onOpen = _this$props2.onOpen,
          _this$props2$disabled = _this$props2.disabled,
          disabled = _this$props2$disabled === void 0 ? false : _this$props2$disabled;
      var open = _this.state.open;
      var result = !open;

      if (!disabled) {
        // 如果有指定的话，就用指定的
        if (typeof currentOpen !== 'undefined') {
          result = currentOpen;
        }

        if (typeof propsOpen === 'undefined') {
          _this.setState({
            open: result
          });
        }

        if ((0, _spauiUtils.isFunction)(onOpen)) {
          onOpen(event, result);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function (event) {
      var _this$props3 = _this.props,
          showDelayTime = _this$props3.showDelayTime,
          trigger = _this$props3.trigger;

      if (trigger !== 'click') {
        clearTimeout(_this.hoverTimeout);
        _this.hoverTimeout = setTimeout(function () {
          _this.handleOpen(event, true);
        }, showDelayTime);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOut", function (event) {
      var _this$props4 = _this.props,
          hideDelayTime = _this$props4.hideDelayTime,
          trigger = _this$props4.trigger;

      if (trigger !== 'click') {
        clearTimeout(_this.hoverTimeout);
        _this.hoverTimeout = setTimeout(function () {
          _this.handleOpen(event, false);
        }, hideDelayTime);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isDropdownToggle", function (item) {
      return item && (0, _spauiUtils.isFunction)(item.type) && item.type.name === 'DropdownToggle';
    });

    _defineProperty(_assertThisInitialized(_this), "isDropdownContent", function (item) {
      return item && (0, _spauiUtils.isFunction)(item.type) && item.type.name === 'DropdownContent';
    });

    _this.nullList();

    _this.el = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.createElement('div');
    _this.state = {
      open: props.open || false,
      left: -9999,
      top: -9999
    };
    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.appendTargetEl();
      this.updateContentPosition();
      this.documentClick(); // 监听下页面变化

      if (_index.haveJQuery) {
        jQuery(window).on('resize', this.handleWindowResize);
      } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
        window.addEventListener('resize', this.handleWindowResize);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (typeof nextProps.open !== 'undefined') {
        this.setState({
          open: nextProps.open || false
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.appendTargetEl();
      this.updateContentPosition();
      this.documentClick();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var target = this.getTarget();
      var body = (0, _index.getBody)();

      try {
        if (typeof _reactDom.createPortal === 'undefined') {
          (0, _reactDom.unmountComponentAtNode)(this.el);
        }

        if (typeof target === 'undefined') {
          body && body.removeChild(this.el);
        } else if (target) {
          target.removeChild(this.el);
        }
      } catch (e) {}

      this.nullList(); // 销毁的时候必须去掉监听事件，不然性能越来越差

      if (_index.haveJQuery) {
        jQuery(window).off('resize', this.handleWindowResize);
      } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.removeEventListener)) {
        window.removeEventListener('resize', this.handleWindowResize);
      }
    } // 暴露出打开/关闭的方法

  }, {
    key: "nullList",
    value: function nullList() {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
      this.toggle = null;
      this.content = null;
      this.targetAppend = false;
      this.bodyAppend = false;
      this.el = null;
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _this$props$className = this.props.classNameMap,
          classNameMap = _this$props$className === void 0 ? {} : _this$props$className;
      return _objectSpread({}, _classname_map["default"], {}, classNameMap);
    } // 获取对象节点

  }, {
    key: "getTarget",
    value: function getTarget() {
      var target = this.props.target;
      var result = target;

      if (result === 'parentNode' && this.toggle) {
        result = this.toggle.parentNode;
      }

      return result;
    } // 添加对应的结构到页面

  }, {
    key: "appendTargetEl",
    value: function appendTargetEl() {
      var open = this.state.open;
      var target = this.getTarget();
      var body = (0, _index.getBody)();

      if (open) {
        if (typeof target === 'undefined') {
          if (!this.bodyAppend && body) {
            body.appendChild(this.el);
            this.bodyAppend = true;
          }
        } else if (target) {
          if (!this.targetAppend) {
            target.appendChild(this.el);
            this.targetAppend = true;
          }
        }
      }
    } // 更新复层的位置

  }, {
    key: "updateContentPosition",
    value: function updateContentPosition() {
      var _this2 = this;

      var open = this.state.open; // React 15点版本的只能通过这个回收

      if (typeof _reactDom.createPortal === 'undefined' && this.el) {
        (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, // 代表当前组件
        this.getDropdownContent(), // 塞进传送门的JSX
        this.el // 传送门另一端的DOM node
        );
      }

      if (open) {
        // React15要延迟下不然拿不到结构
        if (typeof _reactDom.createPortal === 'undefined') {
          setTimeout(function () {
            _this2.setContentPosition();
          }, 4);
        } else {
          this.setContentPosition();
        }
      }
    } // 监听页面点击

  }, {
    key: "documentClick",
    value: function documentClick() {
      var open = this.state.open;
      var documentClickAutoHide = this.props.documentClickAutoHide;

      if (documentClickAutoHide) {
        // 需要回收
        if (open && !this.haveDocumentClick) {
          if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.addEventListener)) {
            document.addEventListener('click', this.handleDocumentClick);
          }

          this.haveDocumentClick = true;
        } else if (!open) {
          this.removeDocumentClick();
        }
      }
    } // 去除页面点击

  }, {
    key: "removeDocumentClick",
    value: function removeDocumentClick() {
      var _this$props5 = this.props,
          trigger = _this$props5.trigger,
          documentClickAutoHide = _this$props5.documentClickAutoHide;

      if (trigger === 'click' && documentClickAutoHide) {
        if (this.haveDocumentClick) {
          if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.removeEventListener)) {
            document.removeEventListener('click', this.handleDocumentClick);
          }

          this.haveDocumentClick = false;
          this._insideClick = false;
        }
      }
    } // 处理页面点击

  }, {
    key: "withToggle",
    // 添加toggle功能
    value: function withToggle() {
      var _this3 = this;

      var toggleChildren = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var trigger = this.props.trigger;
      var open = this.state.open;
      var classNameMap = this.getClassNameMap();
      var subKey = "".concat(key, "-withToggle");
      var result = null;

      if (toggleChildren) {
        if (trigger === 'hover') {
          result = this.withCloneElement(toggleChildren, {
            className: (0, _classnames["default"])(open ? classNameMap.DropdownToggleOpenClassName : ''),
            onMouseOver: this.handleMouseOver,
            onMouseOut: this.handleMouseOut,
            onClick: function onClick() {
              if (_this3.haveDocumentClick) {
                _this3._insideClick = true;
              }
            },
            htmlRef: function htmlRef(el) {
              _this3.toggle = el;
            }
          }, subKey);
        } else {
          result = this.withCloneElement(toggleChildren, {
            className: (0, _classnames["default"])(open ? classNameMap.DropdownToggleOpenClassName : ''),
            onClick: function onClick(event) {
              if (_this3.haveDocumentClick) {
                _this3._insideClick = true;
              }

              _this3.handleOpen(event);
            },
            htmlRef: function htmlRef(el) {
              _this3.toggle = el;
            }
          }, subKey);
        }
      }

      return result;
    } // 添加content

  }, {
    key: "withContent",
    value: function withContent() {
      var _this4 = this;

      var contentChildren = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _this$state = this.state,
          open = _this$state.open,
          left = _this$state.left,
          top = _this$state.top;
      var classNameMap = this.getClassNameMap();
      var subKey = "".concat(key, "-withContent");
      var result = null;
      var style = {};

      if (contentChildren) {
        style = contentChildren.props && contentChildren.props.style || {};
        result = this.withCloneElement(contentChildren, {
          open: open,
          onMouseOver: this.handleMouseOver,
          onMouseOut: this.handleMouseOut,
          onClick: function onClick() {
            _this4._insideClick = true;
          },
          htmlRef: function htmlRef(el) {
            _this4.content = el;
          },
          style: _objectSpread({}, style, {
            left: left,
            top: top
          }),
          className: (0, _classnames["default"])(contentChildren.props && contentChildren.props.className || '', classNameMap.DropdownContent || '')
        }, subKey);
      } else {
        result = contentChildren;
      }

      return _react["default"].createElement(_odAnimate["default"], {
        transitionName: this.props.motionName || 'slide-up',
        component: "div"
      }, open ? result : null);
    }
  }, {
    key: "withCloneElement",
    value: function withCloneElement(element) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var result = null;

      if (element && _typeof(element) === 'object') {
        result = (0, _react.cloneElement)(element, _objectSpread({}, props, {
          key: key || (0, _spauiUtils.getUniqueId)('spaui-dropdown-clone-element')
        }));
      } else {
        result = element;
      }

      return result;
    } // 是否两个children对象，1个是普通对象，1个是下拉面板

  }, {
    key: "isOneNormalChildrenAndOneContentChildren",
    value: function isOneNormalChildrenAndOneContentChildren() {
      var children = this.props.children;
      var result = false;

      if ((0, _spauiUtils.isArray)(children)) {
        // 如果Dropdown只有两个元素，一个是DropdownContent，一个是其他对象，那其他对象就是触发对象
        var childrenIsOk = children.length === 2 && children[0] && children[1];
        var firstChildIsOk = this.isDropdownContent(children[0]) && !this.isDropdownContent(children[1]);
        var secondChildIsOk = this.isDropdownContent(children[1]) && !this.isDropdownContent(children[2]);

        if (childrenIsOk && (firstChildIsOk || secondChildIsOk)) {
          result = true;
        }
      }

      return result;
    } // 获取触发对象

  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this5 = this;

      var _this$props6 = this.props,
          children = _this$props6.children,
          dropdownContent = _this$props6.dropdownContent;
      var key = 'children';
      var result = null;
      var toggleTarget = null;

      if ((0, _spauiUtils.isArray)(children)) {
        result = []; // 如果Dropdown只有两个元素，一个是DropdownContent，一个是其他对象，那其他对象就是触发对象

        if (this.isOneNormalChildrenAndOneContentChildren()) {
          if (this.isDropdownContent(children[0])) {
            toggleTarget = children[1];
          } else {
            toggleTarget = children[0];
          }

          if (this.isDropdownToggle(toggleTarget)) {
            result = this.withToggle(toggleTarget, key);
          } else {
            result = this.withToggle(_react["default"].createElement(_dropdown_toggle["default"], null, toggleTarget), key);
          }
        } else {
          children.map(function (item, index) {
            if (_this5.isDropdownToggle(item)) {
              result.push(_this5.withToggle(item, "".concat(key, "-").concat(index)));
            } else if (!_this5.isDropdownContent(item)) {
              result.push(_this5.withCloneElement(item, "".concat(key, "-").concat(index)));
            }

            return item;
          });
        }
      } else {
        if (this.isDropdownToggle(children)) {
          result = this.withToggle(children, key);
        } else if (!this.isDropdownContent(children)) {
          // 如果有dropdownContent的参数那就把这个当成触发对象
          if (typeof dropdownContent !== 'undefined' && this.isDropdownContent(dropdownContent)) {
            result = this.withToggle(_react["default"].createElement(_dropdown_toggle["default"], null, children), key);
          } else {
            result = children;
          }
        }
      } // 如果是只有一个元素，就直接返回内容


      if (typeof _reactDom.createPortal === 'undefined' && (0, _spauiUtils.isArray)(result) && result.length > 1) {
        result = null; // eslint-disable-line no-console

        console.warn('【spaui-dropdown】React 15+的版本Dropdown内不支持放非DropdownToggle, DropdownContent的内容！');
      } else if ((0, _spauiUtils.isArray)(result) && result.length < 2) {
        result = result[0] || null;
      }

      return result;
    } // 获取下拉内容

  }, {
    key: "getDropdownContent",
    value: function getDropdownContent() {
      var _this6 = this;

      var _this$props7 = this.props,
          children = _this$props7.children,
          dropdownContent = _this$props7.dropdownContent;
      var key = 'dropdownContent';
      var result = null; // 支持通过参数传入

      if (typeof dropdownContent !== 'undefined' && this.isDropdownContent(dropdownContent)) {
        result = this.withContent(dropdownContent, key);
      } else {
        if ((0, _spauiUtils.isArray)(children)) {
          result = [];
          children.map(function (item, index) {
            if (_this6.isDropdownContent(item)) {
              result.push(_this6.withContent(item, "".concat(key, "-").concat(index)));
            }

            return item;
          });
        } else {
          if (this.isDropdownContent(children)) {
            result = this.withContent(children, key);
          }
        }
      } // 如果是只有一个元素，就直接返回内容


      if (typeof _reactDom.createPortal === 'undefined' && (0, _spauiUtils.isArray)(result) && result.length > 1) {
        result = null; // eslint-disable-line no-console

        console.warn('【spaui-dropdown】React 15+的版本Dropdown内不支持放非DropdownToggle, DropdownContent的内容！');
      } else if ((0, _spauiUtils.isArray)(result) && result.length < 2) {
        result = result[0] || null;
      }

      return result;
    } // 设置content的位置

  }, {
    key: "setContentPosition",
    value: function setContentPosition() {
      var _this$props8 = this.props,
          _this$props8$placemen = _this$props8.placement,
          propsPlacement = _this$props8$placemen === void 0 ? '' : _this$props8$placemen,
          _this$props8$defaultP = _this$props8.defaultPlacement,
          defaultPlacement = _this$props8$defaultP === void 0 ? '' : _this$props8$defaultP,
          _this$props8$offsetDa = _this$props8.offsetData,
          offsetData = _this$props8$offsetDa === void 0 ? {} : _this$props8$offsetDa,
          setLocation = _this$props8.setLocation,
          _this$props8$alignmen = _this$props8.alignment,
          alignment = _this$props8$alignmen === void 0 ? '' : _this$props8$alignmen;
      var open = this.state.open;

      var _getClientSize = (0, _index.getClientSize)(),
          clientWidth = _getClientSize.clientWidth,
          clientHeight = _getClientSize.clientHeight;

      var target = this.getTarget();
      var toggleRect = {};
      var contentRect = {};
      var top = 0;
      var left = 0;
      var scrollTop = 0;
      var scrollLeft = 0;
      var contentChildren = {};
      var contentHeight = 0;
      var contentWidth = 0;
      var locationData = {};
      var placement = '';
      var leftOfToggle = 0;
      var topOfToggle = 0;
      var widthOfToggle = 0;
      var heightOfToggle = 0;
      var targetRect = {};
      var leftOfTarget = 0;
      var topOfTarget = 0;
      var getLeftForTopOrBottom;
      var getTopForLeftOrRight;
      var toggle = this.toggle;
      var content = this.content;

      if (open && toggle && toggle.getBoundingClientRect && content && content.getBoundingClientRect) {
        if ((0, _spauiUtils.isFunction)(setLocation)) {
          locationData = setLocation(toggle, content, target, this.props);
          top = locationData.top || 0;
          left = locationData.left || 0;
        } else {
          if (target && typeof target.getBoundingClientRect !== 'undefined') {
            targetRect = target.getBoundingClientRect() || {};
            topOfTarget = targetRect.top || targetRect.y || 0;
            leftOfTarget = targetRect.left || targetRect.x || 0;
          }

          toggleRect = toggle.getBoundingClientRect() || {};
          contentRect = content.getBoundingClientRect() || {};
          scrollTop = (0, _index.getScrollTop)(target);
          scrollLeft = (0, _index.getScrollLeft)(target);
          leftOfToggle = (toggleRect.left || toggleRect.x) + scrollLeft - leftOfTarget;
          topOfToggle = (toggleRect.top || toggleRect.y) + scrollTop - topOfTarget;
          widthOfToggle = toggleRect.width || 0;
          heightOfToggle = toggleRect.height || 0;
          contentHeight = contentRect.height || 0;
          contentWidth = contentRect.width || 0; // 如果content的高度是0的话且子节点存在的话，有可能是因为子节点指定了绝对定位之类的原因导致高度获取不到

          if (contentHeight < 1 && content.children && content.children.length > 0 && content.children[0]) {
            contentChildren = content.children[0];

            if (contentChildren.getBoundingClientRect) {
              contentHeight = contentChildren.getBoundingClientRect().height || 0;
              contentWidth = contentChildren.getBoundingClientRect().width || 0;
            }
          } // 如果是auto的话，判断下最后用哪个方向


          if (propsPlacement === 'auto') {
            if (defaultPlacement === 'left') {
              if (leftOfToggle - contentWidth < 0) {
                placement = 'right';
              }
            } else if (defaultPlacement === 'right') {
              if (leftOfToggle + widthOfToggle + contentWidth > clientWidth) {
                placement = 'left';
              }
            } else if (defaultPlacement === 'bottom') {
              if (topOfToggle + heightOfToggle + contentHeight > clientHeight) {
                placement = 'top';
              }
            } else if (defaultPlacement === 'top') {
              if (topOfToggle - contentHeight < 0) {
                placement = 'bottom';
              }
            }
          } else {
            placement = propsPlacement || defaultPlacement;
          } // 为placement=top or bottom 获取left


          getLeftForTopOrBottom = function getLeftForTopOrBottom() {
            var leftValue = 0;

            if (alignment === 'right') {
              leftValue = leftOfToggle + widthOfToggle - contentWidth;
            } else if (alignment === 'center') {
              leftValue = leftOfToggle - (contentWidth - widthOfToggle) / 2;
            } else {
              leftValue = leftOfToggle;
            }

            return leftValue;
          }; // 为placement=left or right 获取top


          getTopForLeftOrRight = function getTopForLeftOrRight() {
            var topValue = 0;

            if (alignment === 'bottom') {
              topValue = topOfToggle + heightOfToggle;
            } else if (alignment === 'center') {
              topValue = topOfToggle - (contentHeight - heightOfToggle) / 2;
            } else {
              topValue = topOfToggle;
            }

            return topValue;
          };

          if (placement === 'top') {
            if (alignment === 'bottom') {
              top = topOfToggle - contentHeight + heightOfToggle;
            } else {
              top = topOfToggle - contentHeight;
            }

            left = getLeftForTopOrBottom();
          } else if (placement === 'left') {
            top = getTopForLeftOrRight();

            if (alignment === 'right') {
              left = leftOfToggle - contentWidth + widthOfToggle;
            } else {
              left = leftOfToggle - contentWidth;
            }
          } else if (placement === 'right') {
            top = getTopForLeftOrRight();

            if (alignment === 'left') {
              left = leftOfToggle;
            } else {
              left = leftOfToggle + widthOfToggle;
            }
          } else {
            // 默认就是bottom
            if (alignment === 'top') {
              top = topOfToggle;
            } else {
              top = topOfToggle + heightOfToggle;
            }

            left = getLeftForTopOrBottom();
          }

          top = top + (offsetData.top || 0);
          left = left + (offsetData.left || 0);
        }

        this.setState({
          top: top,
          left: left
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof _reactDom.createPortal === 'undefined') {
        return this.getChildren();
      }

      return [this.getChildren(), (0, _reactDom.createPortal)(this.getDropdownContent(), this.el)];
    }
  }]);

  return Dropdown;
}(_react.PureComponent); // 组件标记


_defineProperty(Dropdown, "propTypes", _dropdown_props.propTypes);

_defineProperty(Dropdown, "defaultProps", _dropdown_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Dropdown, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Dropdown;
exports["default"] = _default;